
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { SmsTemplateManager } from "@/components/sms/SmsTemplateManager";

interface AutomatedMessagesProps {
  isModuleEnabled?: boolean;
}

const AutomatedMessages = ({ isModuleEnabled = true }: AutomatedMessagesProps) => {
  const isDisabled = !isModuleEnabled;

  return (
    <Card className={isDisabled ? "opacity-60" : ""}>
      <CardHeader>
        <CardTitle>Templates SMS</CardTitle>
        <CardDescription>
          Configure templates reutilizáveis para suas mensagens SMS de cashback
        </CardDescription>
      </CardHeader>
      <CardContent>
        <SmsTemplateManager />
      </CardContent>
    </Card>
  );
};

export default AutomatedMessages;
